import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "default-form" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr" }
const _hoisted_4 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = { class: "input-row" }
const _hoisted_8 = { class: "input-wr" }
const _hoisted_9 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_10 = { class: "input-row" }
const _hoisted_11 = { class: "input-wr" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_20 = { class: "input-row" }
const _hoisted_21 = { class: "input-wr" }
const _hoisted_22 = { class: "input-row" }
const _hoisted_23 = { class: "input-wr input-price-wr" }
const _hoisted_24 = { class: "initial-deposit-wrapper" }
const _hoisted_25 = { class: "input-row" }
const _hoisted_26 = { class: "toggle-block" }
const _hoisted_27 = {
  key: 0,
  class: "toggle-description"
}
const _hoisted_28 = {
  key: 1,
  class: "toggle-description"
}
const _hoisted_29 = {
  key: 1,
  class: "error-hint"
}
const _hoisted_30 = {
  key: 0,
  class: "input-row refundable"
}
const _hoisted_31 = { class: "toggle-block" }
const _hoisted_32 = {
  key: 0,
  class: "toggle-description"
}
const _hoisted_33 = {
  key: 1,
  class: "input-row"
}
const _hoisted_34 = { class: "input-wr" }
const _hoisted_35 = { class: "toggle-block" }
const _hoisted_36 = {
  key: 2,
  class: "input-row"
}
const _hoisted_37 = { class: "input-wr" }
const _hoisted_38 = { class: "toggle-block" }
const _hoisted_39 = { class: "input-row buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "dashboard-header" }, [
      _createElementVNode("h2", { class: "title-main" }, "Create Estate")
    ], -1)),
    _createElementVNode("form", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Title", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.title.$error }]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.title) = $event)),
            type: "text",
            placeholder: "Title"
          }, null, 2), [
            [
              _vModelText,
              $setup.form.title,
              void 0,
              { trim: true }
            ]
          ]),
          ($setup.v$.title.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.v$.title.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label" }, "Address", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.address.$error }]),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.address) = $event)),
            type: "text",
            placeholder: "Address"
          }, null, 2), [
            [
              _vModelText,
              $setup.form.address,
              void 0,
              { trim: true }
            ]
          ]),
          ($setup.v$.address.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.address.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label" }, "Short Estate Name (9 characters)", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.shortTitle.$error }]),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.shortTitle) = $event)),
            type: "text",
            placeholder: "Estate Name",
            maxlength: "9"
          }, null, 2), [
            [_vModelText, $setup.form.shortTitle]
          ]),
          ($setup.v$.shortTitle.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.v$.shortTitle.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label" }, "Estate Type", -1)),
          _withDirectives(_createElementVNode("select", {
            class: _normalizeClass(["input estate-type-select", { error: $setup.v$.type.$error }]),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.type) = $event)),
            onChange: $setup.syncAppVersionWithEstateType
          }, [
            _cache[15] || (_cache[15] = _createElementVNode("option", {
              value: undefined,
              disabled: ""
            }, "Select type", -1)),
            _createElementVNode("option", {
              value: $setup.EstateType.LEGACY
            }, "Legacy", 8, _hoisted_12),
            _createElementVNode("option", {
              value: $setup.EstateType.RESIDENTIAL_COMMUNITY
            }, "Residential Community", 8, _hoisted_13),
            _createElementVNode("option", {
              value: $setup.EstateType.LAND_SUBDIVISION
            }, "Land Subdivision", 8, _hoisted_14)
          ], 34), [
            [_vModelSelect, $setup.form.type]
          ]),
          ($setup.v$.type.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.v$.type.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["input-wr", { 'locked-select': $setup.isAppVersionLocked }])
        }, [
          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label" }, "App Version", -1)),
          _withDirectives(_createElementVNode("select", {
            class: _normalizeClass(["input app-version-select", { error: $setup.v$.appVersion.$error }]),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.appVersion) = $event)),
            disabled: $setup.isAppVersionLocked
          }, [
            _createElementVNode("option", {
              value: $setup.EstateAppVersion.V1
            }, "V1", 8, _hoisted_17),
            _createElementVNode("option", {
              value: $setup.EstateAppVersion.V2
            }, "V2", 8, _hoisted_18)
          ], 10, _hoisted_16), [
            [_vModelSelect, $setup.form.appVersion]
          ]),
          ($setup.v$.appVersion.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.v$.appVersion.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label" }, "Icon Color", -1)),
          _createElementVNode("label", {
            class: "input-color",
            style: _normalizeStyle({ 'background-color': $setup.form.iconColor })
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.iconColor) = $event)),
              type: "color"
            }, null, 512), [
              [_vModelText, $setup.form.iconColor]
            ])
          ], 4)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode($setup["ToggleButton"], {
                  modelValue: $setup.initDepositCondition,
                  "onUpdate:modelValue": [
                    _cache[6] || (_cache[6] = ($event: any) => (($setup.initDepositCondition) = $event)),
                    $setup.setDepositAndRefundable
                  ],
                  additionalClass: 'large',
                  labelBold: 'toggle-title-font bolder',
                  label: "Initial deposit"
                }, null, 8, ["modelValue"]),
                ($setup.initDepositCondition)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Buyers will be required to pay an initial holding deposit when completing a Contract information form."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28, "Buyers will not be required to pay an initial holding deposit when completing a Contract information form."))
              ])
            ])
          ]),
          ($setup.initDepositCondition)
            ? (_openBlock(), _createBlock($setup["Cleave"], {
                key: 0,
                class: _normalizeClass(["input deposit", [{ error: $setup.v$.initDeposit.$error }]]),
                id: "deposit",
                modelValue: $setup.form.initDeposit,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.initDeposit) = $event)),
                modelModifiers: { trim: true },
                type: "text",
                placeholder: "Initial deposit",
                onBlur: $setup.v$.initDeposit.$touch,
                options: $setup.initDepositOptions
              }, null, 8, ["modelValue", "class", "onBlur"]))
            : _createCommentVNode("", true),
          ($setup.v$.initDeposit.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString($setup.v$.initDeposit.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      ($setup.initDepositCondition)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode($setup["ToggleButton"], {
                modelValue: $setup.form.isRefundable,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.isRefundable) = $event)),
                additionalClass: 'large',
                labelBold: 'toggle-title-font bold',
                label: "Refundable"
              }, null, 8, ["modelValue"]),
              ($setup.initDepositCondition)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _cache[19] || (_cache[19] = _createTextVNode("Buyers will be notified before submitting a Contract information", -1)),
                    _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" form that the holding deposit is " + _toDisplayString(`${$setup.form.isRefundable ? "" : " not"} refundable.`), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.isSuperAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode($setup["ToggleButton"], {
                  modelValue: $setup.form.showInitialHold,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form.showInitialHold) = $event)),
                  additionalClass: 'large',
                  labelBold: 'toggle-title-font bold',
                  label: "Show Initial Hold Functionality"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.isSuperAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode($setup["ToggleButton"], {
                  modelValue: $setup.form.showDocusign,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form.showDocusign) = $event)),
                  additionalClass: 'large',
                  labelBold: 'toggle-title-font bold',
                  label: "Show Docusign Functionality"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("button", {
          class: "button default outlined cancel-btn",
          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.router.go(-1))),
          type: "button"
        }, "Cancel"),
        _createElementVNode("button", {
          class: "button default primary create-btn",
          onClick: $setup.createEstate,
          type: "button"
        }, "Create")
      ])
    ])
  ], 64))
}